import React, { Component } from 'react';
import { withAuthorization } from '../session';
import Modal from 'react-modal';
import Loader from 'react-loader-spinner';
import modalStyle from '../styles/modal';

const INITIAL_STATE = {
    loading: false,
    passwordOne: '',
    passwordTwo: '',
    error: {
        isShow: false,
        title: '',
        message: ''
    }
};

Modal.setAppElement('#root');
class PasswordChange extends Component {

    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    handleSubmit = event => {
        event.preventDefault();
        
        const { passwordOne, passwordTwo } = this.state;
        const isInvalid = passwordOne !== passwordTwo || passwordOne === '';

        if (!isInvalid) {
            this.setState({ loading: true });

            this.props.firebase
                .doPasswordChange(passwordOne)
                .then(() => {
                    this.setState({ ...INITIAL_STATE });
                    this.showModal("Información", "Su contraseña fue cambiada con éxito.");
                })
                .catch(error => {
                    this.setState({ loading: false });
                    this.showModal("Error", "Lo sentimos, no se pudo cambiar la contraseña. La contraseña debe tener al menos 6 caracteres.");
                    console.log(error);
                });
        } else {
            this.showModal("Error", "Los datos introducidos son incorrectos.");
        }
        
    };

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    showModal = (title, message) => {
        this.setState({
            error: {
                isShow: true,
                title: title,
                message: message
            }
        });
    }

    closeModal = () => {
        this.setState({
            error: {
                isShow: false,
                title: '',
                message: ''
            }
        });
    }

    render() {
        const { loading, passwordOne, passwordTwo, error } = this.state;
        const isInvalid =
            passwordOne !== passwordTwo || passwordOne === '';

        return (
            <div>

                <form className="form-signin text-center" onSubmit={this.handleSubmit}>
                    <h1 className="h3 mb-3 font-weight-normal">Cambiar Contraseña</h1>

                    <input value={passwordOne} onChange={this.handleChange} name="passwordOne" type="password" className="form-control" placeholder="Nueva contraseña" required="" />

                    <input value={passwordTwo} onChange={this.handleChange} name="passwordTwo" type="password" className="form-control mt-3" placeholder="Repetir nueva contraseña" required="" />

                    {(!loading) ?
                        <button disabled={isInvalid} className="mt-3 btn btn-lg btn-primary btn-block" type="submit">Cambiar</button>
                        :
                        <div className="nav justify-content-center row">
                            <Loader className="mt-4"
                                type="ThreeDots"
                                color="#263238"
                                height={60}
                                width={60}
                                timeout={0} />
                        </div>
                    }

                </form>

                <Modal
                    isOpen={error.isShow}
                    contentLabel="Modal Example"
                    style={modalStyle}
                    onRequestClose={this.closeErrorModal}>
                    <div className="" style={{ minWidth: '300px', maxWidth: '400px' }}>
                        <h5 className="card-title">{error.title}</h5>
                        <p className="card-text text-break">{error.message}</p>

                        <div className="nav justify-content-end">
                            <button onClick={this.closeModal} className="btn btn-sm btn-dark">Cerrar</button>
                        </div>
                    </div>

                </Modal>
            </div>

        );
    }
}

const condition = authUser => !!authUser;
export default withAuthorization(condition)(PasswordChange);